// "Thông báo của tôi" (20/10/2026) — hộp thư CỦA CHÍNH người đăng nhập: đọc lại
// tin cũ, lọc, tìm, đánh dấu đã đọc / chưa đọc.
//
// Bài cố ý KHÔNG kể tin nào gửi cho ai, vì sao (đó là luật của từng phòng) và
// KHÔNG kể đường tin đi giữa các kênh — chỉ việc người đọc làm trên trang này.

import type { GuideBook } from "../types";

const EVERYONE = [
  "reception",
  "sale",
  "photo",
  "makeup",
  "assistant",
  "retouch",
  "cskh",
  "marketing",
  "accounting",
  "qc",
  "lead",
  "exec",
] as const;

export const MY_NOTIFICATIONS_GUIDES: GuideBook = {
  my_notifications: {
    purpose: "Đọc lại mọi thông báo hệ thống gửi cho bạn trong 90 ngày, tìm đúng tin cần và đánh dấu đã đọc hay chưa đọc.",
    where: [
      'Đầu trang: tên trang "Thông báo của tôi", nút "Đánh dấu đã đọc tất cả" ở mép phải — khi đang lọc, nút đổi thành "Đánh dấu đã đọc N tin đang lọc".',
      'Máy tính: ô "Tìm…", ô "Trạng thái" (Tất cả / Chưa đọc / Đã đọc), ô "Khoảng ngày" và ô "Sắp xếp" nằm một hàng.',
      'Điện thoại: ô "Tìm…" và nút "Bộ lọc" kèm số tiêu chí đang bật; bấm "Bộ lọc" để chọn Trạng thái, Khoảng ngày, Sắp xếp rồi bấm "Xem kết quả".',
      'Dưới bộ lọc: dải chip nhóm — "Tất cả", "Tiền", "Đơn hàng", "Suất chụp", "Ca & nghỉ", "Ảnh & hậu kỳ", "In ảnh", "Chat & khách", "Sự cố & khiếu nại", "Lương & thưởng", "Nội bộ" — mỗi chip kèm số tin. Điện thoại kéo dải chip sang ngang.',
      'Chọn một nhóm có từ hai loại tin trở lên: hiện khung "Loại tin trong nhóm …" với ô tích từng loại, kèm số tin và số chưa đọc.',
      'Giữa trang: danh sách tin — ô chọn, nhãn "Chưa đọc" nếu chưa mở, nhóm · loại tin, thời gian, biểu tượng tròn theo nhóm (đỏ: sự cố, vàng: tiền…), tiêu đề và nội dung, nút ⋯ cuối dòng. Điện thoại mỗi tin là một thẻ.',
      'Tin nhiều dòng (bản tin "Bất thường phát sinh"…): mỗi khoản một dòng, mã đơn in đậm; dưới tin có nút "Xem cả N dòng" (tin nhiều nhóm thì "Xem chi tiết") để mở ra và "Thu gọn" để gập lại.',
      'Chọn từ một tin trở lên: thanh "Đã chọn N tin" hiện ra với nút "Đánh dấu đã đọc", "Đánh dấu chưa đọc", "Bỏ chọn". Ô tích ở đầu cột chọn cả trang.',
      'Cuối danh sách: chuyển trang và chọn số tin mỗi trang (10, 20, 50, 100).',
      'Chuông ở thanh trên chia tin theo ngày ("Hôm nay", "Hôm qua", rồi ngày cụ thể), trình bày từng tin y như trang này; nút "Xem tất cả" mở trang này; dòng "Còn N tin chưa đọc cũ hơn…" trong chuông mở trang này ở chế độ Chưa đọc.',
      'Mục "Thông báo của tôi" trên menu có ô số đỏ: số tin chưa đọc, cùng số với chuông (quá 99 thì ghi "99+").',
    ],
    howItWorks: [
      "Trang chỉ có thông báo gửi cho chính bạn; không ai đọc hay đánh dấu được tin của người khác ở đây.",
      "Tin giữ 90 ngày rồi tự dọn. Mở trang là thấy sẵn mọi tin còn trong hộp thư; đổi \"Khoảng ngày\" để xem hẹp lại.",
      "Bấm vào một tin là tin đó tính đã đọc và mở ngay chỗ liên quan (đơn hàng, ca, khung chat…). Tin gắn với một đơn thì mọi tin của đơn đó cùng tính đã đọc.",
      'Tin dài chỉ hiện hai khoản đầu cho gọn. Bấm "Xem cả N dòng" / "Xem chi tiết" chỉ mở rộng tin ngay tại chỗ — tin KHÔNG bị tính đã đọc và không chuyển trang; muốn mở chỗ liên quan thì bấm vào tiêu đề tin.',
      'Tin "Khách để lại số nhờ gọi lại tư vấn" mở Sổ yêu cầu trên Cổng dịch vụ ở một tab mới; Cổng hỏi "Chìa đọc sổ" lần đầu, xin chìa ở quản lý trực tiếp.',
      'Tin "Khách đang rất bực" bấm vào vẫn mở khung chat của khách; dòng "Mở Sổ khiếu nại trên Cổng" dưới tin mở sổ đó ở tab mới, dùng cùng "Chìa đọc sổ".',
      "Mở một đơn hay một khung chat từ chỗ khác cũng tự tắt tin của đúng đơn hay khung chat đó.",
      "Số đỏ trên chuông và trên mục menu cùng đếm mọi tin chưa đọc của bạn. Đánh dấu ở trang này thì cả hai đổi theo ngay.",
      'Ô "Tìm…" không cần gõ dấu: tìm trong tiêu đề, nội dung, mã đơn và cả tên loại tin (gõ "tien ve" là ra các tin tiền về).',
      "Số trên chip nhóm và trong khung loại tin tính theo trạng thái, khoảng ngày và chữ đang tìm — chọn nhóm này thì chip nhóm khác vẫn giữ số của nó.",
      'Đổi bất kỳ bộ lọc nào là danh sách quay về trang 1. Bộ lọc nằm trên đường dẫn: tải lại trang vẫn giữ đúng tập đang xem.',
      'Đánh dấu nhiều hơn 20 tin một lần thì máy hỏi lại trước khi làm.',
    ],
    statuses: [
      { label: "Chưa đọc", meaning: "Dòng nền xanh nhạt, vạch xanh mép trái, nhãn \"Chưa đọc\" và tiêu đề chữ đậm: tin bạn chưa mở." },
      { label: "Dòng nền trắng, chữ xám", meaning: "Tin đã đọc." },
      { label: "Còn N dòng nữa không kèm trong tin", meaning: "Bản tin chỉ chở tối đa năm khoản mỗi nhóm; các khoản còn lại không gửi kèm — tra ở màn quản lý của việc đó." },
      { label: "Loại khác", meaning: "Tin loại mới chưa có tên riêng — nằm ở nhóm Nội bộ. Nội dung tin vẫn đọc bình thường." },
      { label: "Không có thông báo khớp bộ lọc", meaning: 'Không tin nào khớp các tiêu chí đang chọn — bấm "Bỏ lọc" để xem lại toàn bộ.' },
      { label: "Chưa có thông báo nào", meaning: "Trong 90 ngày gần nhất chưa có tin nào gửi cho bạn." },
      { label: "Chữ đỏ ngay chỗ danh sách", meaning: 'Trang không tải được — câu đỏ nói lý do; bấm "Thử lại".' },
    ],
    blocks: [
      {
        for: [...EVERYONE],
        title: "Tìm lại một tin cũ",
        steps: [
          'Mở mục "Thông báo của tôi" ở cuối nhóm Của tôi, hoặc bấm chuông rồi bấm "Xem tất cả".',
          "Bấm chip nhóm của việc bạn cần (ví dụ \"Tiền\").",
          "Cần hẹp hơn: tích một hay vài loại trong khung loại tin của nhóm đó.",
          'Gõ mã đơn, tên khách hay vài chữ trong tin vào ô "Tìm…".',
          'Tin cũ hơn: đổi "Khoảng ngày"; cần xem tin cũ trước thì đổi "Sắp xếp" sang "Cũ nhất trước".',
          "Bấm vào tin để mở đúng chỗ liên quan.",
        ],
        troubles: [
          "Không thấy tin cũ hơn 90 ngày: hộp thư chỉ giữ 90 ngày, tin cũ hơn đã tự dọn.",
          "Tin có trên Telegram mà ở đây không có: tin đó có thể đã quá 90 ngày, hoặc gửi trước khi hộp thư trong app có — xem trong Telegram.",
          "Bấm vào tin mà đứng yên: tin đó chỉ để đọc, không gắn đơn hay trang nào.",
          "Bấm vào tin mà trang mở ra báo lỗi hoặc trống: chụp màn hình, hỏi trưởng bộ phận.",
        ],
      },
      {
        for: [...EVERYONE],
        title: "Dọn số đỏ trên chuông",
        steps: [
          'Đổi "Trạng thái" sang "Chưa đọc" để chỉ xem tin chưa đọc.',
          'Đọc hết những tin đã xử lý xong: tích các tin đó rồi bấm "Đánh dấu đã đọc" trên thanh "Đã chọn N tin".',
          'Muốn đánh dấu cả nhóm đang lọc: chọn nhóm (và loại nếu cần) rồi bấm "Đánh dấu đã đọc N tin đang lọc" ở đầu trang — chỉ những tin đang lọc bị đánh dấu.',
          'Lỡ đánh dấu một tin chưa xử lý: tích tin đó (hoặc bấm ⋯ cuối dòng) rồi chọn "Đánh dấu chưa đọc" — tin sáng lại trên chuông.',
        ],
        troubles: [
          'Nút "Đánh dấu đã đọc N tin đang lọc" bị mờ: tập đang xem không còn tin chưa đọc nào (hoặc đang xem "Đã đọc").',
          "Số đỏ trên chuông chưa giảm ngay: đợi vài giây hoặc tải lại trang.",
          "Đánh dấu báo lỗi: câu báo nói lý do — làm theo câu đó rồi thử lại.",
        ],
      },
      {
        for: ["lead", "exec"],
        title: "Theo dõi việc cần xử lý mỗi ngày",
        steps: [
          'Mỗi sáng mở trang, đổi "Trạng thái" sang "Chưa đọc" và "Sắp xếp" sang "Chưa đọc lên đầu".',
          'Xem chip "Sự cố & khiếu nại" và "Tiền" trước: bấm từng tin để mở đúng chỗ và xử lý.',
          "Tin chỉ để biết (ví dụ suất đã có người nhận): lọc đúng loại đó rồi đánh dấu đã đọc cả loại một lần.",
        ],
        troubles: [
          "Quá nhiều tin cùng một loại: tích riêng loại đó trong khung loại tin rồi dùng nút đánh dấu tin đang lọc.",
          "Không thấy một nhóm trong dải chip: trong khoảng ngày đang xem bạn chưa có tin nhóm đó.",
        ],
      },
    ],
    askWho: "Thắc mắc về nội dung một tin thì hỏi phòng gửi việc đó hoặc trưởng bộ phận; trang báo lỗi lạ thì báo bộ phận kỹ thuật.",
  },
};
